<template>
  <figure>
    <v-img :src="image_src" :contain="true" height="80px"></v-img>
  </figure>
</template>

<script>
export default {
  data() {
    return {
      image_src: require("@/assets/svg/nuage.svg"),
    };
  },
}
</script>

<style>

</style>